/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_BillingInputs */

const en_admin_nav_billing = /** @type {(inputs: Admin_Nav_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payments & Credits`)
};

const zh_admin_nav_billing = /** @type {(inputs: Admin_Nav_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支付与积分`)
};

/**
* | output |
* | --- |
* | "Payments & Credits" |
*
* @param {Admin_Nav_BillingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_nav_billing = /** @type {((inputs?: Admin_Nav_BillingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_BillingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_nav_billing(inputs)
	return zh_admin_nav_billing(inputs)
});
export { admin_nav_billing as "admin.nav.billing" }